import { RouteRecordRaw } from "vue-router";
import { PermissionEnum } from "@/app/core/enums/PermissionEnum";

export const routePrivateSearch: Array<RouteRecordRaw> = [
  {
    path: "search",
    name: "Search",
    meta: {
      requireAuth: true,
      permissions: [PermissionEnum.LoadsSearch],
    },
    redirect: (to) => {
      return { name: "SearchListings" };
    },
    component: () => import("@/app/private/pages/search-for-orders/SearchForOrders.vue"),
    children: [
      {
        path: "",
        name: "SearchListings",
        component: () =>
          import(
            "@/app/private/pages/search-for-orders/pages/listings/SearchForOrdersListings.vue"
          ),
      },
    ],
  },
];
